import { DateTime } from "luxon";

import { IJob } from "../models/Job";

// A job counts as archived once a month has passed since the last thing happened on it -
// the most recent part action, or its creation date if nothing was ever actioned.
// Shared by the jobs calendar tabs and the bulk delete modal so the two can't disagree.
//
// "Actioned" is removed, damaged or missing, the same three states that finish a job. Reading
// only removedOn dated a job whose last parts were flagged damaged or missing from its creation
// instead, so a job someone finished yesterday could already be sitting in the archive.
export default function isJobArchived(job: IJob): boolean {
  const actionDates = job.jobPartCategories
    ?.flatMap((jpc) => [jpc.partData?.removedOn, jpc.partData?.damageReportedOn])
    .filter((date): date is string => date !== null && date !== undefined)
    .map((date) => new Date(date)) ?? [];

  const oneMonthAgo = DateTime.now().minus({ months: 1 }).toJSDate();

  if (actionDates.length === 0) {
    return new Date(job.created) < oneMonthAgo;
  }

  const mostRecentAction = new Date(
    Math.max(...actionDates.map((d) => d.getTime()))
  );

  return mostRecentAction < oneMonthAgo;
}
